import React, { useEffect } from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';
import DownloadAppButton from '@/UI/Components/DownloadAppButton/DownloadAppButton';
import { useParams } from 'react-router-dom';

const Recovery: React.FC = () => {
	const { open } = useParams<{ open: 'cc' | 'np' }>();
	const destinations = {
		cc: {
			message: 'Redirigiendo a Centro de comando',
			url: 'https://admin.fincluyente.com.mx/es/reset?token='
		},
		np: {
			message: 'Redirigiendo a nuestra app',
			url: 'finclu://recovery?code='
		}
	};
	useEffect(() => {
		const handleRedirect = () => {
			try {
				const urlParams = new URLSearchParams(window.location.search);
				const token = urlParams.get('token');
				if (token && open) {
					window.location.href = destinations[open].url + token;
				}
			} catch (err) {
				console.error(err);
			}
		};
		handleRedirect();
	}, []);

	return (
		<div className="bg-[#1E6091]">
			<div className="w-full h-screen flex flex-col justify-center items-center ">
				<div className="flex flex-col items-center justify-center w-full max-w-[80%] md:max-w-[50%] text-center grow">
					<div className="flex-1 flex flex-col items-center justify-between gap-6 bg-white p-5 md:p-10 max-h-[60%] md:max-h-[50%] rounded-lg">
						<div className="w-full flex flex-col gap-2 items-center">
							<div className="w-28 items-center">
								<img src="/black-logo.png" alt="Fincluyente" />
							</div>
							<Typography size={22} weight="bold" color="black">
								{open ? destinations[open].message : 'Redirigiendo'}
							</Typography>
						</div>
						<div>
							<div className="w-full text-left mb-1">
								<Typography size={16} weight="semibold" color="black">
									Es necesario tener la app de Finclu instalada
								</Typography>
							</div>
							<ul className="flex flex-col gap-2 w-full ml-2 marker:text-white text-left">
								<li>
									<Typography size={16} weight="semibold" color="black">
										1. Presiona abrir con "Finclu"
									</Typography>
								</li>
								<li>
									<Typography size={16} weight="semibold" color="black">
										2. Termina el proceso de cambio de contraseña en la app
									</Typography>
								</li>
							</ul>
						</div>
						<div className="flex flex-col gap-4 items-center">
							<hr className="border-b-2 border-2 w-full" />
							<Typography size={16} color="subtitle">
								En caso de no tener la app instalada, puedes descargarla aquí
							</Typography>
							<div className="flex justify-center items-center">
								<DownloadAppButton></DownloadAppButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Recovery;
